import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./CheckoutAuthModal.css";

export default function CheckoutAuthModal({ open, onClose }) {
  const navigate = useNavigate();
  const cajaRef = useRef(null);

  /* Escape cierra y el foco entra en el modal. Antes la unica salida era
     apuntarle a "Cancel" con el mouse: con el teclado no habia forma de
     cerrarlo, y el foco se quedaba en el boton de atras, debajo del velo. */
  useEffect(() => {
    if (!open) return;

    const alTeclear = (e) => {
      if (e.key === "Escape") onClose?.();
    };

    document.addEventListener("keydown", alTeclear);
    cajaRef.current?.focus();

    /* La pagina de atras no se scrollea mientras el modal esta abierto. */
    const overflowPrevio = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", alTeclear);
      document.body.style.overflow = overflowPrevio;
    };
  }, [open, onClose]);

  if (!open) return null;

  const irA = (mode) =>
    navigate("/store/login", { state: { redirectTo: "/store/checkout", mode } });

  return (
    <div
      className="adc-auth-overlay"
      /* Click afuera cierra. El listener va en el velo y se comprueba que
         el click no venga de adentro, para que arrastrar una seleccion
         desde el texto del modal no lo cierre. */
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div
        className="adc-auth-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="adc-auth-titulo"
        tabIndex={-1}
        ref={cajaRef}
      >
        <h2 id="adc-auth-titulo">Continue to checkout</h2>

        <p className="adc-auth-sub">
          Sign in or create an account to place your order.
        </p>

        <div className="adc-auth-actions">
          <button
            className="adc-auth-login"
            onClick={() => irA("login")}
          >
            Sign in
          </button>

          <button
            className="adc-auth-register"
            onClick={() => irA("register")}
          >
            Create account
          </button>
        </div>

        <button className="adc-auth-close" onClick={onClose}>
          Cancel
        </button>
      </div>
    </div>
  );
}
